<template>
<div class="chapter">
<div class="inner_page">
<h1>Andersonville Diary</h1>
<h4 class="sigil_not_in_toc">Escape, and List of Dead, with Name, Co.,</h4>
<h4 class="sigil_not_in_toc">Regiment, Date of Death and No. Of Grave in Cemetry</h4>
<h2 class="sigil_not_in_toc">John L. Ransom</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?e3530cf2